import { PatientSource } from '@heidi/schema/ml-scribe';

import type { PatientProfile, PatientProfileSearchResult } from '../../../contracts';
import type { SuggestedPatientMatch } from '../suggested-matches';
import { toPatientProfileSearchResult } from './to-patient-profile-search-result';

export function toSuggestedMatchPatientProfile(
  match: SuggestedPatientMatch
): PatientProfile {
  if (match.patientProfile) return match.patientProfile;

  const { firstName, lastName } = splitSuggestedMatchName(match.fullName);

  return {
    id: match.patientProfileId,
    source: PatientSource.HEIDI,
    first_name: firstName,
    last_name: lastName,
    birth_date: match.birthDate ?? null,
    demographic_string: match.fullName,
  } as PatientProfile;
}

export function toSuggestedMatchSearchResult(
  match: SuggestedPatientMatch
): PatientProfileSearchResult {
  if (match.patientProfile) {
    const result = toPatientProfileSearchResult(match.patientProfile);
    if (result) return result;
  }

  const { firstName, lastName } = splitSuggestedMatchName(match.fullName);

  return {
    id: match.patientProfileId,
    source: 'HEIDI',
    first_name: firstName,
    last_name: lastName,
    birth_date: match.birthDate ?? null,
    gender: null,
    demographic_string: match.fullName,
    last_seen_at: null,
    last_session_gist: null,
    session_count: 0,
  };
}

function splitSuggestedMatchName(fullName: string): {
  firstName: string | null;
  lastName: string | null;
} {
  const [firstName, ...lastNameParts] = fullName.trim().split(/\s+/);

  return {
    firstName: firstName || null,
    lastName: lastNameParts.length > 0 ? lastNameParts.join(' ') : null,
  };
}
